import React, { useState } from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import { useLogin, useLogout } from '../../hooks/useAuth';
import styles from './auth.module.css';

const LoginButton = () => {
    const isAuthenticated = useIsAuthenticated();
    const { loginPopup } = useLogin();
    const { logout } = useLogout();
    const [rememberMe, setRememberMe] = useState(false);

    const handleLogin = () => {
        loginPopup(rememberMe);
    };

    const handleLogout = () => {
        logout();
    };

    return (
        <div className={styles['login-button-container']}>
            {isAuthenticated ? (
                <button 
                    className={`${styles['auth-button']} ${styles['logout-button']}`}
                    onClick={handleLogout}
                >
                    Sign Out
                </button>
            ) : (
                <div className={styles['login-controls']}>
                    <button 
                        className={`${styles['auth-button']} ${styles['login-button']}`}
                        onClick={handleLogin}
                    >
                        Sign In
                    </button>
                    <label className={styles['remember-me-label']}>
                        <input 
                            type="checkbox" 
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            className={styles['remember-me-checkbox']}
                        />
                        <span>Remember me for 7 days</span>
                    </label>
                    {rememberMe && (
                        <span className={styles['security-hint']}>
                            Don't use on shared computers
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default LoginButton;
